import { css, cx } from "@emotion/css";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type * as React from "react";
interface ListTitleProps {
    children?: React.ReactNode;
    alignment?: "left" | "center" | "right";
}
//** ListTitle is a component that displays a title for a list item. */
//*
//* @param children - The content to display in the list title.
//* @param verticalAlignment - The vertical alignment of the list title.
//* @returns A React component that displays a title for a list item.
//*
//* @example
//* <ListTitle>Title</ListTitle>
//*
export function ListTitle({ children, alignment = "center" }: ListTitleProps) {
    return <h3 className={cx(listTitleStyles, alignmentStyles[alignment])}>{children}</h3>;
}
export default ListTitle;
const listTitleStyles = css({
    font: text.heading.small,
    //TODO: this needs more consideration, its been styled this way to match existing use cases
    color: themeTokens.color.text.link.default,
    flexGrow: 1,
    margin: 0,
});
const alignmentStyles = {
    left: css({
        alignSelf: "start",
    }),
    center: css({
        alignSelf: "center",
    }),
    right: css({
        alignSelf: "end",
    }),
};
